module.exports = __webpack_public_path__ + "img/inv.9bbcd068.jpg";